import {createAction} from "@reduxjs/toolkit";

// RequestLog type
export const CREATE_REQUEST_LOG = '[REQUEST_LOG] Creating request log';
export const STUDENT_CANCEL_REQUEST_LOG = '[REQUEST_LOG] Canceling request log by student';

// RequestLog actions
export const createRequestLog = createAction(CREATE_REQUEST_LOG);
export const studentCancelRequestLog = createAction(STUDENT_CANCEL_REQUEST_LOG);
